import { create } from 'zustand';
import { Agent, Workflow, Document, ProcessingEvent, SystemMetrics } from '../types';

interface PlatformState {
  // State
  agents: Agent[];
  workflows: Workflow[];
  documents: Document[];
  activeDocument: Document | null;
  processingEvents: ProcessingEvent[];
  systemMetrics: SystemMetrics;
  
  // Actions
  setAgents: (agents: Agent[]) => void;
  updateAgent: (agentId: string, updates: Partial<Agent>) => void;
  setActiveDocument: (document: Document | null) => void;
  addProcessingEvent: (event: ProcessingEvent) => void;
  updateSystemMetrics: (metrics: Partial<SystemMetrics>) => void;
}

export const usePlatformStore = create<PlatformState>((set) => ({
  agents: [],
  workflows: [],
  documents: [],
  activeDocument: null,
  processingEvents: [],
  systemMetrics: {
    activeWorkflows: 0,
    processingDocuments: 0,
    completedToday: 0,
    avgProcessingTime: 0,
    systemHealth: 98.5,
    agentUtilization: {},
  },
  
  setAgents: (agents) => set({ agents }),
  updateAgent: (agentId, updates) => 
    set((state) => ({
      agents: state.agents.map((agent) =>
        agent.id === agentId ? { ...agent, ...updates } : agent
      ),
    })),
  setActiveDocument: (document) => set({ activeDocument: document }),
  addProcessingEvent: (event) =>
    set((state) => ({
      processingEvents: [...state.processingEvents, event].slice(-100), // Keep last 100 events
    })),
  updateSystemMetrics: (metrics) =>
    set((state) => ({
      systemMetrics: { ...state.systemMetrics, ...metrics },
    })),
}));
